import { render } from "./StudioSocialMediaManager.vue?vue&type=template&id=0e4e3fb2"
import script from "./StudioSocialMediaManager.vue?vue&type=script&lang=js"
export * from "./StudioSocialMediaManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__